import { Comment, Fragment } from 'vue';

// Because of Vue 3 we need a helper function to know if a slot is empty
export const isSlotEmpty = (vnodes) => vnodes.every((node) => {
  if (node.type === Comment) {
    return true;
  }

  if (node.type === Text && typeof node.children === 'string' && !node.children.trim()) {
    return true;
  }

  if (
    node.type === Fragment
      && isSlotEmpty(node.children)
  ) {
    return true;
  }

  return false;
});
